import React, { useEffect, useState } from 'react';
import styles from '../style.module.scss';

import { useHistory } from 'react-router-dom';
import NewHeaderComponent from '../../../components/NewHeader/NewHeader';
import ProductCard from './productCard';
import { sellerFilters } from '../constants';
import useProductData from '../Hooks/useProductData';
import Loader from '../../../components/loader';
import { OverlayTrigger, Popover, Form, Modal, Button } from 'react-bootstrap';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Checkbox from '@material-ui/core/Checkbox';
import AddCatalogueComponent from '../../Inventory/addCatalogue';
import AlertComponent from '../../../components/AlertComponent';

import sparkleAnimation from '../../../lotties/Sparkel.json';
import productsAnimation from '../../../lotties/ProductsAdded.json';

import { HiOutlineSearch } from 'react-icons/hi';
import { AiOutlineCloseCircle } from 'react-icons/ai';

import Lottie from 'lottie-react';
import { InfiniteScrollHandle } from '../../../components/InfiniteScroll/infiniteScroll';
import NewLoader from '../../../components/NewLoader';
import BackToDashboard from '../../../components/BackToDashboard';

const RecommendedProducts = () => {
  const history = useHistory();
  const {
    selectedSellerFilter,
    onChangeSellerFilter,
    loading,
    onFetchRecommendedProducts,
    setPageData,
    totalProductsCount,
    pageData,
    filterCategories,
    filterBrands,
    totalProducts,
    onSelectFilter,
    selectedFilterBrands,
    selectedFilterCategories,
    filtersShown,
    setFiltersShown,
    brandFiltersShown,
    setBrandFiltersShown,
    categoryFiltersShown,
    setCategoryFiltersShown,
    onDiscardFilter,
    filteredProducts,
    handlePageChange,
    totalPageCount,
    searchVal,
    handleOnChangeSearch,
    searchModelIdFnc,
    searchedModelId,
    productArray,
    selectedModelFnc,
    clearSearchResult,
    addProductObj,
    productObj,
    showModelDetails,
    showAddNewBtn,
    showCatalogueModal,
    setShowCatalogueModal,
    addInv,
    category,
    handleInvModal,
    getCategoryList,
    showAlert,
    setShowAlert,
    alertMsg,
    showSuccessPopup,
    setShowSuccessPopup,
    successPopupType,
    setSuccessPopupType,
    showAddProduct,
    setShowAddProduct,
    addLoading,
    errorMsg,
    setErrorMsg,
  } = useProductData();

  const loginData = localStorage.getItem('login_data')
    ? JSON.parse(localStorage.getItem('login_data'))
    : null;

  useEffect(() => {
    onFetchRecommendedProducts();
    getCategoryList();
    window.scrollTo(0, 0);
  }, []);

  const FiltersPopover = () => {
    return (
      <Popover
        id={`ppopover-basic`}
        className={`${styles.filterPopup}`}
        style={{
          overflowY: 'auto',
        }}
      >
        <ClickAwayListener
          onClickAway={() => {
            setFiltersShown(false);
          }}
        >
          <Popover.Content>
            <div className={`mb-2 ${styles.filterHeader}`}>
              <span>Brand</span>
              <img
                onClick={() => {
                  setBrandFiltersShown(!brandFiltersShown);
                }}
                src={brandFiltersShown ? '/images/viewMore.svg' : '/images/viewLess.svg'}
              />
            </div>

            {brandFiltersShown && (
              <div className={`${styles.filterRowContainer}`}>
                {filterBrands.length > 0 ? (
                  filterBrands.map((brand, index) => {
                    return (
                      <div className={`d-flex align-items-center ${styles.filterRow}`} key={index}>
                        <div
                          className={`${styles.filterCheckbox}`}
                          onClick={() => onSelectFilter(brand, 'brand')}
                        >
                          {(selectedFilterBrands.includes(brand) || false) && (
                            <img src="/images/Check.svg" />
                          )}
                        </div>
                        <Form.Label
                          htmlFor={`cat_${index}`}
                          className="d-flex align-items-center mb-0 ml-2"
                        >
                          {brand}
                        </Form.Label>
                      </div>
                    );
                  })
                ) : (
                  <div>No results found</div>
                )}
              </div>
            )}

            <div className={`mt-3 mb-2 ${styles.filterHeader}`}>
              <span>Category</span>
              <img
                onClick={() => {
                  setCategoryFiltersShown(!categoryFiltersShown);
                }}
                src={categoryFiltersShown ? '/images/viewMore.svg' : '/images/viewLess.svg'}
              />
            </div>

            {categoryFiltersShown && (
              <div className={`${styles.filterRowContainer}`}>
                {filterCategories.length > 0 ? (
                  filterCategories.map((category, index) => {
                    return (
                      <div className={`d-flex align-items-center ${styles.filterRow}`} key={index}>
                        <div
                          className={`${styles.filterCheckbox}`}
                          onClick={() => onSelectFilter(category, 'category')}
                        >
                          {(selectedFilterCategories.includes(category) || false) && (
                            <img src="/images/Check.svg" />
                          )}
                        </div>
                        <Form.Label
                          htmlFor={`cat_${index}`}
                          className="d-flex align-items-center mb-0 ml-2"
                        >
                          {category}
                        </Form.Label>
                      </div>
                    );
                  })
                ) : (
                  <div>No results found</div>
                )}
              </div>
            )}

            <div className="pt-2 d-flex justify-content-center align-items-center">
              <button className={`btn ${styles.discardBtn}`} onClick={onDiscardFilter}>
                Discard
              </button>

              <button
                className={`${styles.applyBtn} ml-2 btn`}
                onClick={() => {
                  setFiltersShown(false);
                  onFetchRecommendedProducts();
                }}
              >
                Apply
              </button>
            </div>
          </Popover.Content>
        </ClickAwayListener>
      </Popover>
    );
  };

  return (
    <div style={{ marginTop: '-20px' }} className={`pb-1`}>
      {loading && (
        <div
          style={{ paddingRight: loginData?.userJourneyCompleted ? '250px' : '' }}
          className={styles.loader}
        >
          <NewLoader noBackground={true} />
        </div>
      )}
      <AddCatalogueComponent
        searchModelIdFnc={searchModelIdFnc}
        searchedModelId={searchedModelId}
        modelArray={productArray}
        selectedModelFnc={selectedModelFnc}
        clearSearchResult={clearSearchResult}
        addProductObj={addProductObj}
        productObj={productObj}
        showModelDetails={showModelDetails}
        showAddNewBtn={showAddNewBtn}
        show={showCatalogueModal}
        handleClose={() => setShowCatalogueModal(false)}
        addInv={addInv}
        category={category}
      />
      <AlertComponent
        color={alertMsg.color}
        msg={alertMsg.msg}
        open={showAlert}
        handleClose={() => setShowAlert(false)}
      />

      <div className="modal_box">
        <Modal
          className="main_modal"
          show={showSuccessPopup}
          onHide={() => {
            setSuccessPopupType(null);
            setShowSuccessPopup(false);
          }}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Body className="p-5">
            <div className={`text-center ${styles.animationContainer}`}>
              <Lottie
                style={{ marginTop: '-40px', width: '300px' }}
                className={`${styles.modal_sparkleAnimation}`}
                animationData={sparkleAnimation}
                loop={true}
              />
              <Lottie
                style={{ marginTop: '-80px' }}
                className={`${styles.modal_houseAnimation}`}
                animationData={productsAnimation}
                loop={true}
              />
              <h4
                style={{ marginTop: '140px' }}
                className={`${styles.modal_title} ${styles.simpleBlueText}`}
              >
                Congratulations!
              </h4>
              <p className={styles.tinyFont}>Your product has been successfully added</p>
              <Button
                className={styles.modal_button}
                onClick={() => {
                  setSuccessPopupType(null);
                  setShowSuccessPopup(false);
                  // history.push('/dashboard');
                }}
              >
                Continue
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      </div>

      <div
        className={`${styles.recommendedProductsPage} ${
          loginData?.userJourneyCompleted ? 'pl-0' : ''
        }`}
      >
        <div className={`${styles.filtersSection}`}>
          <span className={`${styles.secondaryText}`}>
            {!loginData?.userJourneyCompleted && <BackToDashboard />}
            What’s selling now
          </span>
          <div className={`${styles.filtersContainer}`}>
            <button
              onClick={() => {
                handleInvModal();
              }}
              className={`${styles.addProductsButton}`}
            >
              <img src="/images/PlusBlack.svg" />
              <span>Add Products</span>
            </button>
            <OverlayTrigger
              trigger="click"
              placement="bottom"
              show={filtersShown}
              overlay={FiltersPopover()}
            >
              <button
                onClick={() => {
                  setFiltersShown(!filtersShown);
                }}
                className={`${styles.addProductsButton} ${
                  selectedFilterBrands?.length || selectedFilterCategories?.length
                    ? styles.activeFilters
                    : ''
                }`}
              >
                <img src="/images/Filters.svg" />
                <span className={`ml-1`}>Filter</span>
              </button>
            </OverlayTrigger>

            <div className={`d-flex`}>
              {sellerFilters.map((fil) => {
                return (
                  <button
                    onClick={() => {
                      onChangeSellerFilter(fil.value);
                    }}
                    className={`${styles.sellerFilter} ${
                      selectedSellerFilter == fil.value ? styles.selectedSellerFilter : ''
                    }`}
                  >
                    <span>{fil.label}</span>
                  </button>
                );
              })}
            </div>
          </div>
        </div>

        <div className={`mt-3 ${styles.inputDiv}`}>
          <HiOutlineSearch className="w-20 h-20" stroke="#22C0E7" aria-hidden="true" />
          <input
            id="searchInput"
            type="text"
            className={styles.search_input}
            placeholder={'Search product/model ID'}
            value={searchVal || ''}
            onChange={(e) => handleOnChangeSearch(e)}
          />
          {searchVal ? (
            <AiOutlineCloseCircle
              className={styles.closeIcon}
              stroke="#c4c4c4"
              aria-hidden="true"
              onClick={() => {
                handleOnChangeSearch('');
              }}
            />
          ) : (
            <div style={{ height: '16px', width: '16px' }}></div>
          )}
        </div>

        <div className={`mt-5 ${styles.productCardsContainer}`}>
          <InfiniteScrollHandle
            endMessage={<div></div>}
            dataLength={totalProducts?.length}
            total={totalProductsCount}
            fetchData={() => {
              onFetchRecommendedProducts(false, true);
            }}
            idName="scrollableDiv"
            styles={{ display: 'flex', flexWrap: 'wrap', gap: '30px 2%' }}
          >
            {(selectedSellerFilter !== 'all' || searchVal ? filteredProducts : totalProducts)
              .length ? (
              (selectedSellerFilter !== 'all' || searchVal ? filteredProducts : totalProducts).map(
                (product, idx) => {
                  return (
                    <ProductCard
                      id={idx}
                      data={product}
                      handleInvModal={handleInvModal}
                      selectedModelFnc={selectedModelFnc}
                      showAddProduct={showAddProduct}
                      addProductObj={addProductObj}
                      setShowAddProduct={setShowAddProduct}
                      productObj={productObj}
                      addInv={addInv}
                      addLoading={addLoading}
                      errorMsg={errorMsg}
                      setErrorMsg={setErrorMsg}
                    />
                  );
                }
              )
            ) : (
              <span className={`ml-auto mr-auto`}>No Products Found.</span>
            )}
          </InfiniteScrollHandle>

          {totalProductsCount > totalProducts?.length && (
            <div className="mt-3 d-flex align-items-center">
              <img
                style={{
                  transform: 'rotate(180deg)',
                  cursor: 'pointer',
                }}
                className={`mr-4`}
                src="/images/arrow.svg"
              />
              <h5 className={`mb-0`}>Scroll down to refresh</h5>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default RecommendedProducts;
